/**
 * Dynamic Price in Add to Cart Button
 * Updates the price displayed in the button based on:
 * - Selected variant price
 * - Quantity selected
 * - Any discounts applied
 */

(function() {
  'use strict';

  function getOrCreateQuantityStatusRegion(form) {
    if (!form) return null;

    var region = form.querySelector('[data-quantity-status]');
    if (region) return region;

    region = document.createElement('div');
    region.setAttribute('data-quantity-status', 'true');
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.className = 'visually-hidden';
    form.appendChild(region);

    return region;
  }

  function getLocalizedMessage(languageKey, replacements) {
    var template = window.languages && window.languages[languageKey] ? window.languages[languageKey] : '';

    Object.keys(replacements || {}).forEach(function(key) {
      template = template.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), replacements[key]);
    });

    return template;
  }

  function announceQuantityChange(form) {
    if (!form) return;

    var quantityInput = form.querySelector('[name="quantity"]');
    if (!quantityInput) return;

    var quantity = parseInt(quantityInput.value, 10) || 1;
    var priceElement = form.querySelector('.product-form__price-to-cart');
    var buttonLabel = form.querySelector('.product-form__add-button');
    var productTitleElement = document.querySelector('.product-meta__title, .product__title, h1.product-title, h1');
    var productName = productTitleElement ? (productTitleElement.textContent || '').replace(/\s+/g, ' ').trim() : '';
    var totalText = priceElement ? (priceElement.textContent || '').trim() : '';
    var buttonText = buttonLabel ? (buttonLabel.textContent || '').replace(/\s+/g, ' ').trim() : '';
    var message = productName ? getLocalizedMessage('cartAnnouncementQuantityUpdatedProduct', {
      product: productName,
      quantity: quantity
    }) : getLocalizedMessage('cartAnnouncementQuantityUpdated', {
      quantity: quantity
    });

    if (totalText) {
      message += " " + getLocalizedMessage('cartAnnouncementAddToCartTotal', {
        total: totalText
      });
    } else if (buttonText) {
      message += " " + buttonText + ".";
    }

    var region = getOrCreateQuantityStatusRegion(form);
    if (!region) return;

    region.textContent = '';
    window.setTimeout(function() {
      region.textContent = message;
    }, 30);
  }

  function handleQuantityInputChange(target) {
    var form = target.closest('form[action*="/cart/add"]');
    var quantity = target.value;
    var lastAnnouncedQuantity = target.getAttribute('data-last-announced-quantity');

    updatePriceInButton();

    if (quantity === lastAnnouncedQuantity) {
      return;
    }

    target.setAttribute('data-last-announced-quantity', quantity);
    announceQuantityChange(form);
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function updatePriceInButton() {
    // Get all product forms on the page
    var productForms = document.querySelectorAll('form[action*="/cart/add"]');

    productForms.forEach(function(form) {
      var priceElement = form.querySelector('.product-form__price-to-cart');
      if (!priceElement) return;

      // Get selected variant
      var variantIdInput = form.querySelector('[name="id"]');
      if (!variantIdInput) return;

      var variantId = variantIdInput.value;
      var quantity = parseInt(form.querySelector('[name="quantity"]').value) || 1;

      // Find variant data from the select option or data attribute
      var variantSelector = form.querySelector('#product-select-' + form.dataset.productId);
      var selectedVariant = null;

      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        var product = window.ShopifyAnalytics.meta.product;
        if (product.variants) {
          selectedVariant = product.variants.find(function(v) {
            return v.id == variantId;
          });
        }
      }

      // Fallback: try to get price from hidden input or data attribute
      if (!selectedVariant) {
        var priceInput = form.querySelector('[data-variant-price]');
        if (priceInput) {
          var price = parseInt(priceInput.dataset.variantPrice) || 0;
          selectedVariant = { price: price };
        }
      }

      // Fallback: try to get from the visible price list
      if (!selectedVariant) {
        var priceListElement = form.querySelector('.price-list .price:not(.price--compare)');
        if (priceListElement) {
          var priceText = priceListElement.textContent.trim();
          var priceMatch = priceText.match(/[\d,\.]+/);
          if (priceMatch) {
            var price = parseFloat(priceMatch[0].replace(',', '')) * 100;
            selectedVariant = { price: price };
          }
        }
      }

      if (selectedVariant && selectedVariant.price) {
        var totalPrice = selectedVariant.price * quantity;
        var moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';

        var formattedPrice = formatMoney(totalPrice, moneyFormat);
        priceElement.textContent = formattedPrice;
      }
    });
  }

  // Initialize on page load
  function init() {
    // Update price initially
    updatePriceInButton();

    // Listen for quantity changes
    document.addEventListener('click', function(e) {
      if (e.target.matches('[data-action="increase-picker-quantity"]') ||
          e.target.matches('[data-action="decrease-picker-quantity"]') ||
          e.target.closest('[data-action="increase-picker-quantity"]') ||
          e.target.closest('[data-action="decrease-picker-quantity"]')) {
        var trigger = e.target.closest('[data-action="increase-picker-quantity"], [data-action="decrease-picker-quantity"]');
        var form = trigger ? trigger.closest('form[action*="/cart/add"]') : null;

        setTimeout(function() {
          updatePriceInButton();
          announceQuantityChange(form);
        }, 50);
      }
    });

    // Listen for quantity input changes
    document.addEventListener('input', function(e) {
      if (e.target.matches('[name="quantity"]')) {
        handleQuantityInputChange(e.target);
      }
    });

    document.addEventListener('change', function(e) {
      if (e.target.matches('[name="quantity"]')) {
        handleQuantityInputChange(e.target);
      }
    });

    // Listen for variant changes
    document.addEventListener('change', function(e) {
      if (e.target.matches('.product-form__single-selector') ||
          e.target.matches('[name="id"]')) {
        setTimeout(updatePriceInButton, 50);
      }
    });

    // MutationObserver to catch dynamic price updates
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          var target = mutation.target;
          if (target.classList && (target.classList.contains('price') || target.classList.contains('price-list'))) {
            updatePriceInButton();
          }
        }
      });
    });

    // Observe price elements for changes
    document.querySelectorAll('.price-list').forEach(function(priceList) {
      observer.observe(priceList, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
